export const getHereMapsAPIAutoCompleteUrl = (input: string) =>
  `https://autocomplete.search.hereapi.com/v1/autocomplete?apiKey=${
    process.env.NEXT_PUBLIC_HERE_API_KEY
  }&q=${input.trim()}&in=countryCode:FRA,BEL,ESP&lang=FR`;

export const getHereMapsAPILookupUrl = (id: string) =>
  `https://lookup.search.hereapi.com/v1/lookup?apiKey=${process.env.NEXT_PUBLIC_HERE_API_KEY}&id=${id}`;
